import React, {useState} from "react";
import { useForm } from 'react-hook-form';
import { Modal, Container, Form, Button } from "react-bootstrap"; 

const Contact = (props) => {
    const [getLoader, setLoader] = useState(false);
    const { register, handleSubmit } = useForm();
  
    const onSubmit = (data) => {
        console.log(data);
    }
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>Contact Us</Modal.Header>
        <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>

        <Form.Group controlId="contact_full_name" className='mb-3'>
        <Form.Label>Name*</Form.Label>
        <Form.Control
            type="text"
            className="form-control"
            {...register("full_name")}
            min="3"
            required
        />
        </Form.Group>

        <Form.Group controlId="contact_email" className='mb-3'>
        <Form.Label>Email*</Form.Label>
        <Form.Control
            type="email"
            className="form-control"
            {...register("email")}
            required
        />
        </Form.Group>

        <Form.Group controlId="contact_message" className='mb-3'>
        <Form.Label>Message*</Form.Label>
        <Form.Control
            type="textarea"
            className="form-control"
            {...register("message")}
            multiline
        />
        </Form.Group>
            <Button
                type="submit"
                className="btn btn_submit ml-2"
                align="center"
                disabled={getLoader}
            >
                { getLoader ? "Submitting.." : "Submit"}
            </Button>
        </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Contact;
